import { EventDetail } from "@/mocks/eventDetails";

interface Props {
  event: EventDetail;
}

export default function EventHero({ event }: Props) {
  return (
    <section className="relative h-[420px] md:h-[560px] flex items-end overflow-hidden">
      <img
        src={event.heroImage}
        alt={event.title}
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-black/20" />

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8 pb-10 md:pb-14">
        <span className={`inline-block ${event.categoryColor} text-white text-xs font-semibold px-3 py-1 rounded-full mb-4`}>
          {event.category}
        </span>
        <h1
          className="text-white font-black text-3xl md:text-5xl leading-tight mb-3"
          style={{ fontFamily: "'Noto Serif TC', serif" }}
        >
          {event.title}
        </h1>
        <p className="text-white/75 text-lg">{event.subtitle}</p>
      </div>
    </section>
  );
}
